"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSapphirePassportScoresFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockSapphirePassportScoresFactory = /** @class */ (function (_super) {
    __extends(MockSapphirePassportScoresFactory, _super);
    function MockSapphirePassportScoresFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockSapphirePassportScoresFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockSapphirePassportScoresFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockSapphirePassportScoresFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockSapphirePassportScoresFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockSapphirePassportScoresFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockSapphirePassportScoresFactory;
}(contracts_1.ContractFactory));
exports.MockSapphirePassportScoresFactory = MockSapphirePassportScoresFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_newEpoch",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "CurrentEpochSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "DelayDurationUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "updater",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "updatedAt",
                type: "uint256",
            },
        ],
        name: "MerkleRootUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "merkleRootUpdater",
                type: "address",
            },
        ],
        name: "MerkleRootUpdaterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "pauseOperator",
                type: "address",
            },
        ],
        name: "PauseOperatorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "value",
                type: "bool",
            },
        ],
        name: "PauseStatusUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "currentEpoch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentMerkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_merkleRootUpdater",
                type: "address",
            },
            {
                internalType: "address",
                name: "_pauseOperator",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_initialEpoch",
                type: "uint256",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "isPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastMerkleRootUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleRootDelayDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleRootUpdater",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pauseOperator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "rootsHistory",
        outputs: [
            {
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_newEpoch",
                type: "uint256",
            },
        ],
        name: "setCurrentEpoch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_delay",
                type: "uint256",
            },
        ],
        name: "setMerkleRootDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_merkleRootUpdater",
                type: "address",
            },
        ],
        name: "setMerkleRootUpdater",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_value",
                type: "bool",
            },
        ],
        name: "setPause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_pauseOperator",
                type: "address",
            },
        ],
        name: "setPauseOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "upcomingMerkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_newRoot",
                type: "bytes32",
            },
        ],
        name: "updateMerkleRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "protocol",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_proof",
                type: "tuple",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "protocol",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_proof",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_epoch",
                type: "uint256",
            },
        ],
        name: "verifyForEpoch",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
